import React, { useEffect, useState } from "react";
import {
  Box,
  Alert,
  SkeletonCircle,
  SkeletonText,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
  Img,
  Text,
  WrapItem,
  Flex,
} from "@chakra-ui/react";
import "./fashion.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";

import { apiUrl } from "../../ApiUrl/ApiUrl";
import Slider from "react-slick";
import { Link, NavLink } from "react-router-dom";

function TopOffers() {
  const [topOffers, settopOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const PreviousBtn = (props) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <h1 style={{ color: "black", fontSize: "45px" }}>
          {" "}
          <GrFormPrevious />{" "}
        </h1>
      </div>
    );
  };
  const NextBtn = (props) => {
    const { className, onClick } = props;
    return (
      <Box className={className} onClick={onClick} display="none">
        <h1 style={{color: "black", fontWeight: "bolder", fontSize: "45px" }}>
          {" "}
          <GrFormNext />{" "}
        </h1>
      </Box>
    );
  };

  var settings = {
    prevArrow: <PreviousBtn />,
    nextArrow: <NextBtn />,
    infinite: true,
    speed: 400,
    slidesToShow: 6,
    slidesToScroll: 1,
        autoplay: true, // Enable auto-scrolling
  autoplaySpeed: 2000, // Adjust speed (2 seconds per slide)
  pauseOnHover: true, // Pause when hovered

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const getFashion = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allbooks`)
      .then((res) => res.json())
      .then((res) => settopOffers(res))
      .catch((err) => setError(true))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getFashion();
  }, []);

  if (loading) {
    return (
      <>
        <Box padding="6" boxShadow="lg" bg="white">
          <SkeletonCircle size="100" />
          <SkeletonText mt="4" noOfLines={8} spacing="4" />
        </Box>
      </>
    );
  }
  if (error) {
    return (
      <>
        <Alert status="error" w="70%" m="auto" textAlign={"center"}>
          <AlertIcon />
          <AlertTitle>Opps!</AlertTitle>
          <AlertDescription>Please Refresh and try again.</AlertDescription>
        </Alert>
      </>
    );
  }
  return (
    <>
      <Text
        paddingTop={{ md: "120px", lg: "20px" }}
        marginLeft={{ lg: "30px" }}
        fontSize={{ base: "10px", md: "20px", lg: "30px" }}
        display={{ base: "none", md: "block", lg: "block" }}
      >
        {" "}
        Recommended Products
      </Text>        
           <Box display={"flex"} mt="20px" boxShadow="rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px" p='1' bg='white' >

           
<Box w={{ base: '80%', md: '75%', lg: '100%' }} m="auto" className="OffSlider">
<Slider {...settings}>
        {topOffers.filter(item=>item.subcatname==="software").map(item =>
        <NavLink to={`/products/view/${item.id}`} key={Date.now()+item.item_id+Math.random()}>
            <Box m="5px" alignItems="center" textAlign={"center"} >
            <Img maxWidth="210px" h="210px" m="auto" _hover={{ transform: "scale(1.1)", transition: "400ms" }} p="10px" src={item.imagePath} alt="" />
            <Text fontWeight="500" fontSize={{base:"13px", md:"12px", lg:"14px"}} noOfLines={2}> {item.booktitle}</Text>
                <Flex textAlign={"center"} justifyContent={'space-around'} w="50%" m="auto">
                                                                    <Text fontSize={"15px"} fontWeight={"600"} >   ₹ {item.descprice}</Text>
                                                                    <Text  fontSize={"12px"}><del> ₹ {item.originalprice}</del></Text>
                </Flex>
           
                  <Text fontWeight={"medium"} mt="8px" fontSize={{base:"13px", md:"14px", lg:"15px"}} color={"green"}>  <span class="pr-1">Max</span>{Math.round(((item.originalprice - item.descprice) / item.originalprice) * 100)}% Off
                                                                    </Text>
                                                                                                      </Box>
        </NavLink>
        )}

    </Slider>
    </Box>
                {/* mobile version */}
                
             <Box
                      display={{ base: "block", md: "none", lg: "none" }}
                      bg="#D3E3FD"
                      p="10px"
                      backgroundImage={""}
                    >
                      <Box
                        mb="20px"
                        mt="5px"
                        alignItems={"center"}
                        display="flex"
                        justifyContent={"space-between"}
                      >
                        
                        <Text fontWeight={"500"} fontSize="19px">
                          
                        Recommended Products
                        </Text>
                        {/* <Button size="sm" colorScheme="messenger" onClick={() => Router.push("/products?maincat=Cloths-Accessories")}>
                          View All sdfgh
                        </Button> */}
                   <Link to="/products?maincat=software" onClick={() => localStorage.setItem('subcatname', 'software')} className="flex items-center justify-center bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-lg p-2 hover:from-gray-700 hover:to-gray-800 transition-all duration-300 shadow-md w-[100px] sm:w-auto">
View All
</Link>
                        
                      </Box>
                      <Box
                        className="itemGrid"
                        display={{ base: "grid", md: "none", lg: "none" }}
                      >
                        {topOffers
                          .filter((item) => item.subcatname==="software")
                          .slice(0, 10) // Limits the result to 10 items
                          .map((item, index) => (
                            <NavLink
                              to={`/products/view/${item.id}`}
                              key={Date.now() + item.id + Math.random()}
                            >
                              <Box
                                borderRadius="6px"
                                m="5px"
                                bg="white"
                                alignItems="center"
                                textAlign={"center"}
                                border="1px solid silver"
                              >
                                <Img
                                  maxWidth="170px"
                                  h="170px"
                                  m="auto"
                                  _hover={{ transform: "scale(1.1)", transition: "400ms" }}
                                  p="10px"
                                  src={item.imagePath}
                                  alt=""
                                />
                                <Text fontWeight="500" px="5px" noOfLines={2}>
                                  
                                  {item.booktitle}
                                </Text>
                                <Flex
                                  textAlign={"center"}
                                  justifyContent={"space-around"}
                                  w="70%"
                                  alignItems={"center"}
                                  m="auto"
                                >
                                  <Text fontSize={"15px"} fontWeight={"600"}>
                                    
                                    ₹ {item.descprice}
                                  </Text>
                                  <Text fontSize={"12px"}>
                                    <del> ₹ {item.originalprice}</del>
                                  </Text>
                                </Flex>
            
                                <Text pb="10px" fontWeight={"medium"} color={"green"}>
                                <span class="pr-1">Max</span>
                      {Math.round(
                        ((item.originalprice - item.descprice) /
                          item.originalprice) *
                          100
                      )} {item.discount} % Off
                                </Text>
                              </Box>
                            </NavLink>
                          ))}
                      </Box>
                    </Box>
            {/* mobile version end */}
        </Box>
      <Text
        paddingTop={{ md: "120px", lg: "20px" }}
        marginLeft={{ lg: "30px" }}
        fontSize={{ base: "10px", md: "20px", lg: "30px" }}
        display={{ base: "none", md: "block", lg: "block" }}
      >
        {" "}
        Recommended Books
      </Text>        
           <Box display={"flex"} mt="20px" boxShadow="rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px" p='1' bg='white' >

           
<Box w={{ base: '80%', md: '75%', lg: '100%' }} m="auto" className="OffSlider">
<Slider {...settings}>
        {topOffers.filter(item=>item.recomandate===1).map(item =>
        <NavLink to={`/products/view/${item.id}`} key={Date.now()+item.item_id+Math.random()}>
            <Box m="5px" alignItems="center" textAlign={"center"} >
            <Img maxWidth="210px" h="210px" m="auto" _hover={{ transform: "scale(1.1)", transition: "400ms" }} p="10px" src={item.imagePath} alt="" />
            <Text fontWeight="500" fontSize={{base:"13px", md:"12px", lg:"14px"}} noOfLines={2}> {item.booktitle}</Text>
                <Flex textAlign={"center"} justifyContent={'space-around'} w="50%" m="auto">
                                                                    <Text fontSize={"15px"} fontWeight={"600"} >   ₹ {item.descprice}</Text>
                                                                    <Text  fontSize={"12px"}><del> ₹ {item.originalprice}</del></Text>
                </Flex>
           
                  <Text fontWeight={"medium"} mt="8px" fontSize={{base:"13px", md:"14px", lg:"15px"}} color={"green"}>  <span class="pr-1">Max</span>{Math.round(((item.originalprice - item.descprice) / item.originalprice) * 100)}% Off
                                                                    </Text>
                                                                                                      </Box>
        </NavLink>
        )}

    </Slider>
    </Box>
                {/* mobile version */}
                
             <Box
                      display={{ base: "block", md: "none", lg: "none" }}
                      bg="#D3E3FD"
                      p="10px"
                      backgroundImage={""}
                    >
                      <Box
                        mb="20px"
                        mt="5px"
                        alignItems={"center"}
                        display="flex"
                        justifyContent={"space-between"}
                      >
                        
                        <Text fontWeight={"500"} fontSize="19px">
                          
                        Recommended Products
                        </Text>
                        {/* <Button size="sm" colorScheme="messenger" onClick={() => Router.push("/products?maincat=Cloths-Accessories")}>
                          View All sdfgh
                        </Button> */}
                  <Link to="/products?maincat=software" onClick={() => localStorage.setItem('subcatname', 'software')} className="flex items-center justify-center bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-lg p-2 hover:from-gray-700 hover:to-gray-800 transition-all duration-300 shadow-md w-[100px] sm:w-auto">
View All
</Link>
                        
                      </Box>
                      <Box
                        className="itemGrid"
                        display={{ base: "grid", md: "none", lg: "none" }}
                      >
                        {topOffers
                          .filter((item) => item.subcatname==="software")
                          .slice(0, 10) // Limits the result to 10 items
                          .map((item, index) => (
                            <NavLink
                              to={`/products/view/${item.id}`}
                              key={Date.now() + item.id + Math.random()}
                            >
                              <Box
                                borderRadius="6px"
                                m="5px"
                                bg="white"
                                alignItems="center"
                                textAlign={"center"}
                                border="1px solid silver"
                              >
                                <Img
                                  maxWidth="170px"
                                  h="170px"
                                  m="auto"
                                  _hover={{ transform: "scale(1.1)", transition: "400ms" }}
                                  p="10px"
                                  src={item.imagePath}
                                  alt=""
                                />
                                <Text fontWeight="500" px="5px" noOfLines={2}>
                                  
                                  {item.booktitle}
                                </Text>
                                <Flex
                                  textAlign={"center"}
                                  justifyContent={"space-around"}
                                  w="70%"
                                  alignItems={"center"}
                                  m="auto"
                                >
                                  <Text fontSize={"15px"} fontWeight={"600"}>
                                    
                                    ₹ {item.descprice}
                                  </Text>
                                  <Text fontSize={"12px"}>
                                    <del> ₹ {item.originalprice}</del>
                                  </Text>
                                </Flex>
            
                                <Text pb="10px" fontWeight={"medium"} color={"green"}>
                                <span class="pr-1">Max</span>
                      {Math.round(
                        ((item.originalprice - item.descprice) /
                          item.originalprice) *
                          100
                      )} {item.discount} % Off
                                </Text>
                              </Box>
                            </NavLink>
                          ))}
                      </Box>
                    </Box>
            {/* mobile version end */}
        </Box>
    </>
  );
}

export default TopOffers;
